"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const foundations_1 = require("@airstudio/foundations");
const actions = require("./actions");
exports.update = (dispatch) => {
    return async (item) => {
        dispatch(actions.updateRequest(item));
        try {
            const { data: { user: me } } = await foundations_1.Api.client.put('/users/me', { item });
            dispatch(actions.updateSuccess(me));
        }
        catch (error) {
            dispatch(actions.updateFailure(foundations_1.Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
//# sourceMappingURL=operations.js.map